import React from 'react';
import { useState } from 'react';

import { useMiniAppSDK } from '@context/SDKConfigContext.tsx';
import { useSDKHandler } from '@features/method-tester/hooks/index.ts';

import { VERSION_0_3 } from '@/constant';
import { useJsBridgeVersion } from '@/context/JsBridgeVersionContext.tsx';
import { ERROR_CODE_MESSAGE_MAP } from '@/features/method-tester/constants';
import { OPERATION_KEY } from '@/features/method-tester/types/SDKCallResult.ts';
import { Button } from '@asphalt-react/button';
import { Card } from '@asphalt-react/card';
import { Loader } from '@asphalt-react/loader';
import { Textfield } from '@asphalt-react/textfield';
import { Heading } from '@asphalt-react/typography';
import { OpenGopayDeeplinkResult } from '@gopay/miniapp-client';

export const LaunchUri = () => {
  const [uri, setUri] = useState<string>('https://play.app.goo.gl/bn6i');
  const {
    isLoading,
    response: uriResponse,
    invokeSDKActionV0_3,
    invokeSDKActionV1,
  } = useSDKHandler<OpenGopayDeeplinkResult>();

  const sdk = useMiniAppSDK();
  const { version } = useJsBridgeVersion();
  const [selectedErrorCode, setSelectedErrorCode] = useState<number | null>(
    null
  );

  const triggerDeeplink = async () => {
    try {
      const options = {
        ...(selectedErrorCode && {
          error: {
            operation_key: OPERATION_KEY.DEEPLINK,
            code: selectedErrorCode,
          },
        }),
      };
      if (version === VERSION_0_3) {
        await invokeSDKActionV0_3(() => sdk.openGopayDeeplink(uri), options);
      } else {
        await invokeSDKActionV1('GPNavigator', 'launchUri', {
          uri,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resetSelection = () => setSelectedErrorCode(null);

  function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    setUri(event.target.value);
  }

  return (
    <Card>
      <div className="flex w-full justify-between flex-wrap">
        <Heading h6>Open Uri</Heading>
        <Button size="xs" onClick={triggerDeeplink} disabled={isLoading}>
          Launch Uri
        </Button>
      </div>
      <div className="flex gap-4">
        {ERROR_CODE_MESSAGE_MAP.deeplink.map(({ code, message }) => (
          <label key={code} className="flex items-center gap-1">
            <input
              type="radio"
              name="ERROR_CODE"
              value={code}
              checked={selectedErrorCode === code}
              onChange={() => setSelectedErrorCode(code)}
            />
            {message}
          </label>
        ))}
      </div>
      <Button size="xs" onClick={resetSelection}>
        Reset Error Code
      </Button>
      <div className="pt-2">
        <Textfield
          type="text"
          placeholder="Enter the URI"
          value={uri}
          onChange={onInputChange}
          stretch={true}
          size="s"
        ></Textfield>
      </div>

      {isLoading && <Loader />}
      {uriResponse && (
        <div className="mt-2 w-full">
          <pre
            data-testid="launch-uri-response"
            className="overflow-auto text-sm bg-gray-100 p-2 rounded"
          >
            {JSON.stringify(uriResponse, null, 2)}
          </pre>
        </div>
      )}
    </Card>
  );
};
